const getDefaultState = () => ({
  addDevice: {
    group_id: 0
  },
  addReport: {}
})
export default {
  state: getDefaultState(),
  getters: {
    getAddDevice: state => state.addDevice,
    getAddReport: state => state.addReport
  },
  mutations: {
    updateAddDevice (state, data) {
      state.addDevice[data.prop] = data.value
    },
    updateAddReport (state, data) {
      state.addReport[data.prop] = data.value
    },
    resetFormsState (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    pushReport ({state, commit}) {
      commit('appendReport', { ...state.addReport, id: Math.floor(Math.random() * 9 + 100) })
      state.addReport = {}
    },
    pushDevice ({state, commit}) {
      commit('appendObject', {
        ...state.addDevice,
        id: Math.floor(Math.random() * 9 + 100),
        dt_install: new Date(),
        date: new Date(),
        lat: 0,
        lng: 0,
        icon: '//panel-scannergps.com/img/markers/objects/land-truck.svg',
        params: {}
      })// todo refactor for id from db
      state.addDevice = { group_id: 0 }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/forms.js